
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";

// index page sections
import Hero from "./IndexSections/Hero.js";
import Carousel from "./IndexSections/Carousel.js";


class Index extends React.Component {
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <Hero />
          
          {/* Excellence Section */}
          <section className="section bg-gradient-warning">
            <Container>
              <Row className="row-grid align-items-center">
                <Col lg="12" className="text-center">
                  <div className="mb-5">
                    <div className="icon icon-xl icon-shape bg-white shadow rounded-circle text-warning mb-4">
                      <i className="ni ni-diamond" />
                    </div>
                    <h2 className="display-3 text-white font-weight-bold">
                      Notre engagement envers l'excellence
                    </h2>
                    <p className="lead text-white opacity-8 mt-4">
                      Chez Solution Nügaz, l'excellence n'est pas qu'un objectif, c'est notre promesse. 
                      Nous nous distinguons par notre approche rigoureuse tant dans nos services à la clientèle 
                      que dans la qualité de nos produits énergétiques.
                    </p>
                  </div>
                </Col>
              </Row>
              
              <Row className="row-grid">
                <Col lg="6">
                  <div className="card bg-white shadow border-0 mb-4">
                    <div className="card-body p-5">
                      <div className="d-flex">
                        <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                          <i className="ni ni-satisfied" />
                        </div>
                        <div className="pl-4">
                          <h5 className="title text-success">Excellence du service client</h5>
                          <p className="description">
                            Service personnalisé et accompagnement professionnel pour chaque client. 
                            Notre équipe d'experts vous guide dans vos décisions énergétiques avec 
                            transparence et intégrité.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                
                <Col lg="6">
                  <div className="card bg-white shadow border-0 mb-4">
                    <div className="card-body p-5">
                      <div className="d-flex">
                        <div className="icon icon-shape bg-gradient-primary rounded-circle text-white">
                          <i className="ni ni-atom" />
                        </div>
                        <div className="pl-4">
                          <h5 className="title text-primary">Excellence des produits</h5>
                          <p className="description">
                            Fourniture de gaz naturel de la plus haute qualité grâce à nos partenaires 
                            de confiance. Solutions énergétiques adaptées à vos besoins spécifiques 
                            avec des prix compétitifs.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          
          <Carousel />
          
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default Index;
